module.exports = __webpack_public_path__ + "VIPV22.png?66a837b63680d60cb00b1d8cf00d0b68";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV22.png
// module id = 117
// module chunks = 0